import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { TypeaheadService, CustomerItem } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-custact-customer',
  templateUrl: './custact-customer.component.html',
  styleUrls: ['./custact-customer.component.css']
})
export class CustactCustomerComponent implements OnInit {
    custactNo;

    custactCustomerKeyno;

    public edit?: Edit;

    public custNoButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.edit!.cust_no ?? '0' }];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.custactNo = this.stateService.getStateParams()['custact_no'];
        this.custactCustomerKeyno = this.stateService.getStateParams()['custact_customer_keyno'];
    }

    private async loadEdit() {
        if (!!this.custactNo && !!this.custactCustomerKeyno) {
            this.edit = (await this.datatask.Post(1170, {
                custact_no: this.custactNo,
                custact_customer_keyno: this.custactCustomerKeyno
            }))[0];
        }
    }

    public searchCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit?.customer_name ?? '',
            custtype: 'S',
            lastselect: 'SEARCH'
        });
    }

    public onCustomerNameSelected(event?: CustomerItem) {
        this.edit!.cust_no = !!event ? '' + event.item_id : '0';
        this.edit!.customer_name = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1171, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    custact_customer_keyno: string;
    custact_no: string;
    cust_no: string;
    customer_name: string;
    isactive: string;
}
